import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import './Dashboard.css';
import { useEffect } from 'react';
import * as directSubscriptionsService from '../services/directSubscriptions';
import { subscriptionsApi } from '../api/subscriptions';

const navigationItems = [
	{ name: 'Announcements', icon: 'campaign' },
	{ name: 'Notifications', icon: 'notifications' },
	{ name: 'Events', icon: 'event' },
	{ name: 'Files', icon: 'folder' },
	{ name: 'People', icon: 'people' },
	{ name: 'Teams', icon: 'groups' },
	{ name: 'Ministries', icon: 'church' },
	// { name: 'Reports', icon: 'assessment' },
	{ name: 'Organization', icon: 'business' },
	{ name: 'Subscription', icon: 'payments' },
];

function Dashboard() {
	const {
		orgData,
		userData,
		hasActiveSubscription,
		subscription,
		setSubscription,
	} = useAuth();
	const primaryColor = orgData?.primaryColor || '#4b95a3';

	// Filter navigation items based on subscription status
	const filteredNavigationItems = hasActiveSubscription
		? navigationItems
		: navigationItems.filter(
				(item) =>
					item.name === 'Organization' || item.name === 'Subscription'
		  );

	const completeNavigationItems =
		userData?.accessLevel === 'SuperAdmin'
			? [
					...filteredNavigationItems,
					{ name: 'Assemblie Admin', icon: 'admin_panel_settings' },
			  ]
			: filteredNavigationItems;

	const sidebarStyle = {
		'--primary-color': primaryColor,
		'--primary-color-light': `${primaryColor}1A`,
	};

	useEffect(() => {
		// If we don't have subscription data but we have user data
		if (
			!subscription &&
			userData &&
			userData.organizations?.adminOrgs?.length > 0
		) {
			const fetchSubscription = async () => {
				try {
					// Try direct access first
					try {
						const directSubscriptionData =
							await directSubscriptionsService.getOrganizationSubscription(
								userData.organizations.adminOrgs[0].id
							);
						setSubscription(directSubscriptionData);
					} catch (directError) {
						console.error(
							'Direct subscription fetch failed in Dashboard:',
							directError
						);

						// Fall back to regular API
						const subscriptionData =
							await subscriptionsApi.getOrganizationSubscription(
								userData.organizations.adminOrgs[0].id
							);
						setSubscription(subscriptionData);
					}
				} catch (error) {
					console.error(
						'Failed to fetch subscription in Dashboard:',
						error
					);
					// Continue without subscription data
				}
			};

			fetchSubscription();
		}
	}, [userData, subscription, setSubscription, hasActiveSubscription]);

	return (
		<DashboardLayout>
			<div className='dashboard-content-wrapper'>
				{/* Subscription warning - now outside and above the dashboard grid */}
				{!hasActiveSubscription && (
					<div className='subscription-warning'>
						<p>
							Your organization doesn't have an active
							subscription. Please subscribe to access all
							features.
						</p>
						<Link
							to='/dashboard/subscription'
							className='subscription-cta'>
							Subscribe Now
						</Link>
					</div>
				)}

				{/* Dashboard grid with navigation items */}
				<div className='dashboard-grid'>
					{completeNavigationItems.map((item) => (
						<Link
							key={item.name}
							to={
								item.name === 'Assemblie Admin'
									? '/dashboard/admin'
									: `/dashboard/${item.name.toLowerCase()}`
							}
							className='dashboard-card'
							style={sidebarStyle}>
							<span className='material-icons card-icon'>
								{item.icon}
							</span>
							<h3>{item.name}</h3>
						</Link>
					))}
				</div>
			</div>
		</DashboardLayout>
	);
}

export default Dashboard;
